<label>
  <input
    #input
    type="radio"
    [name]="name"
    [value]="value"
    [ngModel]="actualValue"
    (ngModelChange)="inputOnChange($event)"
    [disabled]="disabled"
  />
  <span><ng-content></ng-content></span>
</label>
